import React from 'react';
import { styled } from '@mui/material/styles';
import { AccordionSummary } from '@mui/material';
import { ChevronRight } from '@piiqtechnologies/svg-icons';

const PeekAccordionSummary = styled(
// `any` element type: AccordionSummary is an OverridableComponent whose ref
// element depends on the overload (button vs anchor), which a fixed generic
// cannot satisfy.
React.forwardRef((props, ref) => (React.createElement(AccordionSummary, Object.assign({ ref: ref, expandIcon: React.createElement(ChevronRight, { fontStyle: "fontSize: 1rem" }) }, props)))))(({ theme }) => ({
    flexDirection: "row-reverse",
    borderRadius: theme.spacing(0.8),
    "& .MuiAccordionSummary-expandIconWrapper": {
        color: theme.palette.primary.main,
        "&.Mui-expanded": {
            transform: "rotate(90deg)",
        },
    },
    "& .MuiAccordionSummary-content": {
        marginLeft: theme.spacing(1),
    },
}));

export { PeekAccordionSummary, PeekAccordionSummary as default };
